import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import autoBind from 'react-autobind'
import { Link } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table'
import ActionButtons from '.././home/ActionButtons';

 const propTypes = {
  dispatch: PropTypes.func.isRequired,
  boxesList: PropTypes.any,
}

 class ShowBoxes extends Component {
  constructor(){
    super();
    autoBind(this);
  }
render(){
  const { boxesList } = this.props
   const tableStyles = {
    stripedRows: true,
    displaySelectAll: false,
    adjustForCheckbox: false,
    selectable: false,
    displayRowCheckbox: false,
  }
  return(
    <div>
      <h2>Boxes</h2>
      <div style={{marginLeft: '20px'}} className="action-buttons">
        <Link to="/boxes/new">
          <RaisedButton
            label="Add New Box"
            primary
          />
        </Link>
      </div>
      <Table selectable={false}>
          <TableHeader
            displaySelectAll={tableStyles.displaySelectAll}
            adjustForCheckbox={tableStyles.adjustForCheckbox}
          >
            <TableRow
              selectable={tableStyles.selectable}
            >
              <TableHeaderColumn>Name</TableHeaderColumn>
              <TableHeaderColumn>Length</TableHeaderColumn>
              <TableHeaderColumn>Width</TableHeaderColumn>
              <TableHeaderColumn>Height</TableHeaderColumn>
              <TableHeaderColumn>Approved</TableHeaderColumn>
              <TableHeaderColumn>Sequence</TableHeaderColumn>
              <TableHeaderColumn style={{ textAlign: 'center' }}>Actions</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            stripedRows={tableStyles.stripedRows}
            displayRowCheckbox={tableStyles.displayRowCheckbox}
          >
            { boxesList && boxesList.map((box, i) => {
                return <TableRow key={i}>
                        <TableRowColumn key={i}>{box.name}</TableRowColumn>
                        <TableRowColumn key={i}>{box.length}</TableRowColumn>
                        <TableRowColumn key={i}>{box.width}</TableRowColumn>
                        <TableRowColumn key={i}>{box.height}</TableRowColumn>
                        <TableRowColumn key={i}>
                          <Checkbox defaultChecked={box.approved} disabled/>
                        </TableRowColumn>
                        <TableRowColumn key={i}>{box.sequence}</TableRowColumn>
                        <TableRowColumn key={i}>
                          <ActionButtons
                            onEdit={`/boxes/edit/${box.id}`}
                          />
                        </TableRowColumn>
                      </TableRow>
              })}
          </TableBody>
        </Table> 
    </div>
  )
}
}

ShowBoxes.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    boxesList: state.boxes.boxesList,
  };
}

export default connect(mapStateToProps)(ShowBoxes) 


// WEBPACK FOOTER //
// ./src/components/boxes/ShowBoxes.js